"use client";

import { UsageView } from "@/components/usage/usage-view";

export default function UsagePage() {
  return <UsageView months={12} showUpgradeCta showDocsLink showHeader />;
}
